"use client";
import { cn as r } from "../../../lib/utils.es.js";
import c from "../icon/Icon.es.js";
import { Fragment as m, jsx as e } from "react/jsx-runtime";
var b = (i) => {
  const { children: a, loading: s, className: l, iconClassName: n, ...o } = i;
  return /* @__PURE__ */ e(m, { children: s ? /* @__PURE__ */ e("div", {
    className: r("lib:flex lib:items-center lib:justify-center", l),
    ...o,
    children: /* @__PURE__ */ e(c, {
      className: r("lib:size-10", n),
      name: "loader"
    })
  }) : a });
};
export {
  b as Loader,
  b as UiLoader
};
